'use strict';
'use es6';

var _FormValidator = require('./validation/FormValidator');

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _FormElement = require('./validation/FormElement');

var _selectors = require('./constants/selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var passwordResetRequestForm = document.querySelector(_selectors.PASSWORD_RESET_REQUEST.FORM);

  var formValidator = new _FormValidator2.default({
    form: passwordResetRequestForm,
    fields: {
      email: {
        selector: _selectors.PASSWORD_RESET_REQUEST.EMAIL_INPUT,
        validationRule: _FormElement.requiredValidation
      }
    },
    onSubmit: function onSubmit() {
      return passwordResetRequestForm.submit();
    }
  });

  formValidator.init();
}, false);


//////////////////
// WEBPACK FOOTER
// ./js/password_reset_request_asset.js
// module id = 11
// module chunks = 3